angular
  .module('surfsightApp.controllers')

  .controller('EdgeEventVideosController', [
    '$scope',
    '$timeout',
    '$http',
    '$filter',
    '$localStorage',
    '$mdDialog',
    'nominatimLookUp',
    'dataFromCaller',
    'edgeFactoryV2',
    '$translate',
    function (
      $scope,
      $timeout,
      $http,
      $filter,
      $localStorage,
      $mdDialog,
      nominatimLookUp,
      dataFromCaller,
      edgeFactoryV2,
      $translate1
    ) {
      $scope.userToken = $localStorage.userToken
      $scope.currentUserOrganizationId =
        $localStorage.currentUserOrganization.id
      const edge = dataFromCaller.edge
      $scope.videosCount = 0
      const event = dataFromCaller.edge_event
      $scope.edge_event = {
        ...event,
        AMPLITUDE_KEY,
        get translationsSrc () {
          return `./locale/lytx-event-media/${$translate1.use()}.json`
        }
      }
      $scope.MAPS_HERE_API_KEY = MAPS_HERE_API_KEY
      $scope.edge = {
        ...edge,
        imei: edge.imei || edge.uri
      }
      $scope.componentErrorLytxEventMedia = e => {
        console.log('componentErrorLytxEventMedia')
        console.log(e)
      }

      nominatimLookUp
        .reverseLookup($scope.edge_event)
        .then(function (locationdata) {
          $scope.edge_event.location = locationdata.title || ''
        })
        .catch(function () {})
      $scope.closeEventVideo = id => {
        const index = $scope.eventFiles.findIndex(e => e.id === id)
        if (index === -1) return
        $scope.eventFiles.splice(index, 1)
      }
      $scope.cancel = function () {
        $mdDialog.cancel()
      }
    }
  ])
